module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1031-a97b829d80dea6e4852c214fb14937ef.png";